var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDefaultMerchantHead = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#DCE0E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.7297C8 11.9085 11.9312 8.00003 16.7805 8.00003H21.83V38H16.7805C11.9312 38 8 34.0916 8 29.2703V16.7297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3658 32.3703C23.3658 27.549 27.297 23.6406 32.1463 23.6406H38V29.0966C38 33.9179 34.0688 37.8263 29.2195 37.8263H23.3658V32.3703Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3658 13.4561C23.3658 18.2773 27.297 22.1858 32.1463 22.1858H38V16.7297C38 11.9084 34.0688 8 29.2195 8H23.3658V13.4561Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultMerchantHead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default_merchant_head.1b3142517dbd8c199c7308370d682bfc.svg";